export function minify(s: string){
    return s
      .replace(/\>[\r\n ]+\</g, "><")
      .replace(/(<.*?>)|\s+/g, (m, $1) => $1 ? $1 : ' ')
      .trim()
  }